<div
  class="running-line-container"
  [style.background]="background ? getBackground() : ''"
  [class]="background && !isMobile && !footer ? 'running-line-height' : ''"
  [style]="isMobile && footer ? 'margin: 0; padding: 0' : ''"
>
  <div class="marquee playfair">
    <div class="marquee-content" #marqueeContent>
      <div class="marquee-child" *ngIf="!otherText" [style]="background ? 'color: white;' : ''">
        <app-texts class="line-pre"
          [style]="background ? 'color: white' : '' "
          [texts]="[
          {text: [' Private access to the world’s finest hotels, jets, yachts and premium airport services ', ' Private access to the world’s finest hotels, jets, yachts and premium airport services '],},
        ]"
        />
        <app-texts class="line-pre"
                   [style]="background ? 'color: white' : '' "
                   [texts]="[
          {text: [' Private access to the world’s finest hotels, jets, yachts and premium airport services ', ' Private access to the world’s finest hotels, jets, yachts and premium airport services '],},
        ]"
        />
      </div>
      <div class="marquee-child" *ngIf="otherText">
        <app-texts class="line-pre"
                   [texts]="text"
        />
        <app-texts class="line-pre"
                   [texts]="text"
        />
        <app-texts class="line-pre"
                   [texts]="text"
        />
        <app-texts class="line-pre"
                   [texts]="text"
        />
        <app-texts class="line-pre"
                   [texts]="text"
        />
        <app-texts class="line-pre"
                   [texts]="text"
        />
      </div>
    </div>
  </div>
</div>
